import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '10.5231 6.7221'
  const rightTransformOrigin = '41.7142 6.7221'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 8.54228C0 8.54228 18.07 7.22232 19.62 6.89232C21.17 6.56232 20.55 0.342276 8.8 1.22228C3.74 1.60228 0 8.54228 0 8.54228Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M1.12012 6.7221C1.12012 6.7221 5.19012 2.9821 8.17012 2.5421C11.1501 2.1021 18.0801 5.40213 19.6201 5.07213C21.1601 4.74213 16.7501 0.022092 9.49012 0.342092C4.42012 0.562092 1.12012 6.7221 1.12012 6.7221Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M52.2373 8.54216C52.2373 8.54216 34.1673 7.2222 32.6173 6.8922C31.0673 6.5622 31.6873 0.342154 43.4373 1.22215C48.4973 1.60215 52.2373 8.54216 52.2373 8.54216Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M51.1172 6.7221C51.1172 6.7221 47.0472 2.9821 44.0672 2.5421C41.0872 2.1021 34.1572 5.40213 32.6172 5.07213C31.0772 4.74213 35.4872 0.022092 42.7472 0.342092C47.8172 0.562092 51.1172 6.7221 51.1172 6.7221Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="10.1187"
            y1="9.82291"
            x2="10.1187"
            y2="3.09353"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="42.1186"
            y1="9.82279"
            x2="42.1186"
            y2="3.09341"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
